import React from 'react';
import { useTranslation } from 'react-i18next';

import { FormSectionCard } from 'components/_basic/FormSectionCard/FormSectionCard';
import { SalesPlanProducts } from 'components/BusinessToolForm/components/SalesPlanProducts';

import { ISalesPlanProductVolumesProps } from './types';

export const SalesPlanProductVolumes: React.FC<ISalesPlanProductVolumesProps> = ({
  productsName: name,
  fields,
  disabled,
  onAddRow,
  onRemoveRow,
}) => {
  const { t } = useTranslation();

  return (
    <FormSectionCard
      disabled={disabled}
      title={t('marketingAndSales.sales.products.title')}
      collapsible
      aiFieldName={name}
      aiFieldType="complex"
    >
      <SalesPlanProducts
        name={name}
        fields={fields}
        disabled={disabled}
        onAddRow={onAddRow}
        onRemoveRow={onRemoveRow}
      />
    </FormSectionCard>
  );
};
